// src/helpers/ProtectedRoute.jsx
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "./permission.js";
import { showToast } from "../components/toast.jsx";

const ProtectedRoute = ({ module, action = "view", children }) => {
  const hasAccess = hasPermission(module, action);

  useEffect(() => {
    if (!hasAccess) {
      showToast.error("You Don't Have Enough Permission To Access This Section.");
    }
  }, [hasAccess]);

  if (!hasAccess) {
    // Redirect to dashboard or 403 page
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;